import { yup } from '@framework/validation';
import { isParentWidgetScopeReadonly } from '../../../../../validator/utils/parent-scope/isParentWidgetScopeReadonly';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { evaluateExpression } from '../../../../expressions/evaluate/evaluateExpression';
import { mapReferenceToPath } from '../../../../expressions/evaluate/mapReferenceToPath';
import { createEvaluationVariables } from '../../../../expressions/evaluate/variables/IEvaluationVariables';
import { collectExpressionReferences } from '../../../../expressions/references/collectExpressionReferences';
import {
  ICreateWidgetFormSchemaInput,
  IParentWidgetScope,
} from '../../../IWidgetType';
import { createCommonFormSchema } from '../common/createCommonFormSchema';
import { IHiddenWidget } from './IHiddenWidget';

export function createHiddenWidgetSchema(
  input: ICreateWidgetFormSchemaInput<IHiddenWidget>,
) {
  const { widget, parentScope } = input;

  switch (widget.dataType) {
    case Datatype.Boolean:
      return createCommonFormSchema(
        setStaticTransform(yup.boolean().notRequired(), widget, parentScope),
        widget,
      );
    case Datatype.Number:
      return createCommonFormSchema(
        setStaticTransform(yup.number().notRequired(), widget, parentScope),
        widget,
      );
    case Datatype.String:
      return createCommonFormSchema(
        setStaticTransform(yup.string().notRequired(), widget, parentScope),
        widget,
      );
    default:
      return createCommonFormSchema(
        setStaticTransform(yup.mixed().notRequired(), widget, parentScope),
        widget,
      );
  }
}

function setStaticTransform(
  schema: yup.AnySchema,
  widget: IHiddenWidget,
  parentScope: IParentWidgetScope,
) {
  if (!('defaultValue' in widget)) return schema;
  if (widget.defaultValue == null) return schema;
  if (isParentWidgetScopeReadonly(parentScope)) return schema;

  const expression = widget.defaultValue;

  const references = collectExpressionReferences(expression);
  const paths = references.map(r => mapReferenceToPath(r));

  return schema.parentWhen(
    paths,
    (values, schema: yup.AnySchema, context: any) => {
      const variables = createEvaluationVariables(references, values);
      const result = evaluateExpression(expression, { variables });
      return schema.transform(() => result);
    },
  );
}
